@if ((tracker?.batteryLevel | typeOf) === 'number' || (tracker?.batteryLife | typeOf) === 'number') {
  <span>
    @if (showBatteryIcon) {
      <fa-icon
      [icon]="batteryIcon"></fa-icon>
    }
    @if (batteryLabel) {
      {{ batteryLabel }}
    }
    @if ((tracker.batteryLevel | typeOf) === 'number') {
      @if (batteryLabel) {
        &nbsp;&#448;&nbsp;
      }
      {{ (tracker.batteryLevel / 100) | percent }}
    }
  </span>
}
